var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bj-col bj-col-12" }, [
    _c("div", { staticClass: "bj-form-title" }, [
      _vm._v(
        " " + _vm._s(_vm.$t("ExternalOrders.newAdd.receivingInformation")) + " "
      ),
      !_vm.isReciverEdit && _vm.isShowEdit
        ? _c(
            "span",
            {
              staticClass: "link right",
              on: { click: _vm.onEditReceiverInfo },
            },
            [_vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Modify")))]
          )
        : _vm._e(),
      _vm.isReciverEdit
        ? _c(
            "span",
            {
              staticClass: "link right",
              staticStyle: { "margin-left": "10px" },
              on: { click: _vm.saveReceiverInfo },
            },
            [_vm._v(_vm._s(_vm.$t("saveText")))]
          )
        : _vm._e(),
      _vm.isReciverEdit
        ? _c(
            "span",
            {
              staticClass: "link right",
              on: { click: _vm.cancelReceiverInfo },
            },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          )
        : _vm._e(),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryName"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.receiverName))])
            : _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.receiverName,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "receiverName", $$v)
                  },
                  expression: "receiverInfoVO.receiverName",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryPhone"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.phone))])
            : _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "phone", $$v)
                  },
                  expression: "receiverInfoVO.phone",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("ExternalOrders.newAdd.DestinationCountry")) + " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.country))])
            : _c("BjSelectLov", {
                attrs: {
                  "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                  placeholder: _vm.$t("chooseText"),
                },
                model: {
                  value: _vm.receiverInfoVO.country,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "country", $$v)
                  },
                  expression: "receiverInfoVO.country",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryState")) + " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.province))])
            : _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.province,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "province", $$v)
                  },
                  expression: "receiverInfoVO.province",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliverySuburb"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.district))])
            : _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.district,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "district", $$v)
                  },
                  expression: "receiverInfoVO.district",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryPostcode"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.zipCode))])
            : _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.SHORT_NAME,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.zipCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "zipCode", $$v)
                  },
                  expression: "receiverInfoVO.zipCode",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryAddress1"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.deliveryAddress1))])
            : _c("BjInput", {
                attrs: {
                  type: "textarea",
                  "show-word-limit": "",
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.deliveryAddress1,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "deliveryAddress1", $$v)
                  },
                  expression: "receiverInfoVO.deliveryAddress1",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.DeliveryAddress2"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [_vm._v(_vm._s(_vm.receiverInfoVO.deliveryAddress2))])
            : _c("BjInput", {
                attrs: {
                  type: "textarea",
                  "show-word-limit": "",
                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.deliveryAddress2,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "deliveryAddress2", $$v)
                  },
                  expression: "receiverInfoVO.deliveryAddress2",
                },
              }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "bj-form-item" }, [
      _c("div", { staticClass: "bj-formItemLabel" }, [
        _vm._v(_vm._s(_vm.$t("ExternalOrders.newAdd.emailAddress"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-form-item-value" },
        [
          !_vm.isReciverEdit
            ? _c("span", [
                _vm._v(_vm._s(_vm.receiverInfoVO.deliveryEmailAddress)),
              ])
            : _c("BjInput", {
                attrs: {
                  maxlength: _vm.MAX_LENGTH.NORMAL_REMARK,
                  placeholder: _vm.$t("inputText"),
                },
                model: {
                  value: _vm.receiverInfoVO.deliveryEmailAddress,
                  callback: function ($$v) {
                    _vm.$set(_vm.receiverInfoVO, "deliveryEmailAddress", $$v)
                  },
                  expression: "receiverInfoVO.deliveryEmailAddress",
                },
              }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }